/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import {fetchVersionInfo as versionFetchVersionInfo} from '../api/Version'

export const REQUEST_VERSION_INFO = 'REQUEST_VERSION_INFO'
export const RECEIVE_VERSION_INFO = 'RECEIVE_VERSION_INFO'

export const fetchVersionInfo = () => dispatch => {
    dispatch(requestVersionInfo());
    return versionFetchVersionInfo().then(
        function (response) {
            dispatch(receiveVersionInfo(response));
        }
    );
}

const requestVersionInfo = () => {
    return {
        type: REQUEST_VERSION_INFO,
    }
}

const receiveVersionInfo = (build) => {
    return {
        type: RECEIVE_VERSION_INFO,
        build: build,
    }
}